// Ilustraciones vectoriales (SVG) hechas a mano para el portal de inicio:
// una veterinaria, un perro y un gato con estilo "flat" amigable y
// redondeado, a juego con la paleta de marca. Versión más animada y
// expresiva: ojos grandes con brillo y parpadeo, colas y orejas con más
// movimiento, y corazones/chispas flotando alrededor de la escena. No son
// fotografías ni imágenes generadas por un modelo de IA de imágenes — este
// entorno no tiene esa herramienta disponible — pero están pensadas para
// transmitir calidez y dinamismo.

export function IlustracionHero() {
  return (
    <svg viewBox="0 0 520 440" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="260" cy="400" rx="220" ry="24" fill="#0f766e" opacity="0.08" />

      {/* Veterinaria */}
      <g className="animar-flotar-lento">
        <circle cx="185" cy="150" r="58" fill="#fde8d4" />
        {/* cabello */}
        <path d="M130 130 Q135 75 185 78 Q235 75 240 130 Q240 105 185 100 Q130 105 130 130 Z" fill="#5b3a29" />
        {/* bata */}
        <path d="M120 380 L128 232 Q185 210 242 232 L250 380 Z" fill="#ffffff" stroke="#e2e8f0" strokeWidth="3" />
        <path d="M170 236 L185 260 L200 236" fill="none" stroke="#0EA5A4" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        {/* brazos: uno acariciando al perro */}
        <path d="M128 250 Q95 275 100 320" fill="none" stroke="#ffffff" strokeWidth="26" strokeLinecap="round" />
        <path d="M242 250 Q290 260 305 250" fill="none" stroke="#ffffff" strokeWidth="26" strokeLinecap="round" />
        {/* estetoscopio */}
        <path d="M160 245 Q160 290 185 290 Q210 290 210 245" fill="none" stroke="#334155" strokeWidth="5" strokeLinecap="round" />
        <circle cx="185" cy="298" r="10" fill="#334155" />
        {/* cachetes sonrojados */}
        <circle cx="148" cy="163" r="10" fill="#fca5a5" opacity="0.55" />
        <circle cx="222" cy="163" r="10" fill="#fca5a5" opacity="0.55" />
        {/* cara: ojos grandes con brillo y parpadeo */}
        <g className="animar-parpadeo" style={{ transformOrigin: "165px 149px" }}>
          <circle cx="165" cy="149" r="6.5" fill="#334155" />
          <circle cx="167.5" cy="146.5" r="2" fill="#ffffff" />
        </g>
        <g className="animar-parpadeo" style={{ transformOrigin: "205px 149px", animationDelay: "0.15s" }}>
          <circle cx="205" cy="149" r="6.5" fill="#334155" />
          <circle cx="207.5" cy="146.5" r="2" fill="#ffffff" />
        </g>
        <path d="M168 170 Q185 184 202 170" fill="none" stroke="#334155" strokeWidth="4.5" strokeLinecap="round" />
      </g>

      {/* Corazón flotante (la veterinaria acariciando al perro) */}
      <path
        d="M300 195 C300 187 310 187 312 195 C314 187 324 187 324 195 C324 204 312 213 312 213 C312 213 300 204 300 195 Z"
        fill="#fb7185"
        className="animar-particula"
        style={{ animationDelay: "0.4s" }}
      />

      {/* Perro */}
      <g transform="translate(300,215)">
        <ellipse cx="60" cy="150" rx="70" ry="18" fill="#0f766e" opacity="0.08" />
        <g className="animar-flotar">
          <path d="M10 90 Q0 40 45 35 Q60 20 90 35 Q125 45 110 90 Q120 130 60 145 Q0 130 10 90 Z" fill="#f5a95f" />
          {/* orejas con leve aleteo */}
          <ellipse cx="20" cy="45" rx="16" ry="26" fill="#e18a3c" transform="rotate(-25 20 45)" className="animar-flotar-lento" style={{ transformOrigin: "20px 45px" }} />
          <ellipse cx="100" cy="45" rx="16" ry="26" fill="#e18a3c" transform="rotate(25 100 45)" className="animar-flotar-lento" style={{ transformOrigin: "100px 45px", animationDelay: "0.5s" }} />
          {/* ojos grandes con brillo y parpadeo */}
          <g className="animar-parpadeo" style={{ transformOrigin: "40px 84px" }}>
            <circle cx="40" cy="84" r="8" fill="#334155" />
            <circle cx="43" cy="81" r="2.4" fill="#ffffff" />
          </g>
          <g className="animar-parpadeo" style={{ transformOrigin: "80px 84px", animationDelay: "0.2s" }}>
            <circle cx="80" cy="84" r="8" fill="#334155" />
            <circle cx="83" cy="81" r="2.4" fill="#ffffff" />
          </g>
          <ellipse cx="60" cy="102" rx="9" ry="7" fill="#334155" />
          {/* boca feliz + lengua afuera */}
          <path d="M45 112 Q60 124 75 112" fill="none" stroke="#334155" strokeWidth="4" strokeLinecap="round" />
          <ellipse cx="60" cy="122" rx="7" ry="10" fill="#fb7185" />
          <circle cx="25" cy="98" r="8" fill="#fca5a5" opacity="0.5" />
          <circle cx="95" cy="98" r="8" fill="#fca5a5" opacity="0.5" />
          <path d="M108 120 Q140 108 130 78" fill="none" stroke="#f5a95f" strokeWidth="14" strokeLinecap="round" className="animar-cola" />
        </g>
      </g>

      {/* Gato */}
      <g transform="translate(60,255)">
        <ellipse cx="45" cy="120" rx="55" ry="14" fill="#0f766e" opacity="0.08" />
        <g className="animar-flotar-lento">
          <path d="M0 60 Q5 20 45 25 Q85 20 90 60 Q95 100 45 112 Q-5 100 0 60 Z" fill="#94a3b8" />
          <path d="M8 30 L20 5 L32 34 Z" fill="#94a3b8" />
          <path d="M58 34 L70 5 L82 30 Z" fill="#94a3b8" />
          {/* ojos grandes con brillo y parpadeo */}
          <g className="animar-parpadeo" style={{ transformOrigin: "30px 63px", animationDelay: "0.35s" }}>
            <circle cx="30" cy="63" r="6.5" fill="#1e293b" />
            <circle cx="32.5" cy="60.5" r="2" fill="#ffffff" />
          </g>
          <g className="animar-parpadeo" style={{ transformOrigin: "62px 63px", animationDelay: "0.5s" }}>
            <circle cx="62" cy="63" r="6.5" fill="#1e293b" />
            <circle cx="64.5" cy="60.5" r="2" fill="#ffffff" />
          </g>
          <circle cx="20" cy="72" r="6" fill="#fca5a5" opacity="0.45" />
          <circle cx="72" cy="72" r="6" fill="#fca5a5" opacity="0.45" />
          <path d="M40 76 L45 80 L50 76" fill="none" stroke="#1e293b" strokeWidth="3.5" strokeLinecap="round" />
          <path d="M8 78 L-14 74 M8 82 L-15 84 M82 78 L104 74 M82 82 L105 84" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
          <path d="M88 95 Q118 102 110 62" fill="none" stroke="#94a3b8" strokeWidth="12" strokeLinecap="round" className="animar-cola" style={{ animationDelay: "0.3s" }} />
        </g>
      </g>

      {/* Huellitas y chispas decorativas, titilando */}
      <g fill="#0EA5A4">
        <circle cx="460" cy="90" r="7" opacity="0.22" className="animar-particula" />
        <circle cx="480" cy="70" r="4" opacity="0.22" className="animar-particula" style={{ animationDelay: "0.6s" }} />
        <circle cx="444" cy="72" r="4" opacity="0.22" className="animar-particula" style={{ animationDelay: "1.1s" }} />
      </g>
      <g fill="#fbbf24">
        <path d="M40 36 L42.5 41 L48 41.5 L44 45 L45 50.5 L40 48 L35 50.5 L36 45 L32 41.5 L37.5 41 Z" opacity="0.6" className="animar-particula" style={{ animationDelay: "0.8s" }} />
      </g>
    </svg>
  );
}

export function IlustracionPortal() {
  return (
    <svg viewBox="0 0 320 420" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg">
      {/* Marco de celular */}
      <rect x="20" y="10" width="280" height="400" rx="36" fill="#0f172a" />
      <rect x="32" y="34" width="256" height="352" rx="16" fill="#ffffff" />
      <rect x="130" y="20" width="60" height="10" rx="5" fill="#1e293b" />

      {/* Encabezado de la app */}
      <rect x="32" y="34" width="256" height="64" rx="16" fill="#0EA5A4" />
      <circle cx="64" cy="66" r="18" fill="#ffffff" opacity="0.9" />
      <path d="M56 66 Q64 54 72 66 Q64 78 56 66 Z" fill="#0EA5A4" />
      <rect x="92" y="56" width="120" height="10" rx="5" fill="#ffffff" opacity="0.9" />
      <rect x="92" y="72" width="80" height="8" rx="4" fill="#ffffff" opacity="0.7" />

      {/* Campanita con notificación pulsante */}
      <circle cx="258" cy="52" r="14" fill="#ffffff" opacity="0.18" />
      <path d="M258 45 v3 M251 56 Q251 47 258 47 Q265 47 265 56 L268 60 L248 60 Z" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="animar-rebote" />
      <circle cx="266" cy="46" r="8" fill="#fb7185" className="animar-onda" style={{ transformOrigin: "266px 46px" }} />
      <circle cx="266" cy="46" r="5" fill="#fb7185" className="animar-latido" style={{ transformOrigin: "266px 46px" }} />

      {/* Tarjeta: expediente */}
      <rect x="48" y="112" width="224" height="70" rx="14" fill="#f0fdfa" stroke="#99f6e4" strokeWidth="2" />
      <circle cx="76" cy="147" r="16" fill="#fbbf24" />
      <rect x="102" y="130" width="110" height="9" rx="4.5" fill="#134e4a" />
      <rect x="102" y="147" width="150" height="7" rx="3.5" fill="#0f766e" opacity="0.6" />
      <rect x="102" y="160" width="90" height="7" rx="3.5" fill="#0f766e" opacity="0.4" />

      {/* Tarjeta: certificado (con palomita que rebota) */}
      <rect x="48" y="196" width="224" height="60" rx="14" fill="#eff6ff" stroke="#bfdbfe" strokeWidth="2" />
      <rect x="64" y="212" width="28" height="28" rx="6" fill="#3b82f6" />
      <path d="M72 226 L78 232 L90 218" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="animar-rebote" style={{ transformOrigin: "78px 225px" }} />
      <rect x="102" y="210" width="140" height="9" rx="4.5" fill="#1e3a8a" />
      <rect x="102" y="227" width="100" height="7" rx="3.5" fill="#1d4ed8" opacity="0.6" />

      {/* Tarjeta: notificación (con corazón latiendo) */}
      <rect x="48" y="270" width="224" height="60" rx="14" fill="#fef3c7" stroke="#fde68a" strokeWidth="2" />
      <circle cx="76" cy="300" r="16" fill="#f59e0b" />
      <path
        d="M76 306 C 65 298, 65 289, 72 289 C 75 289, 76 291, 76 292 C 76 291, 77 289, 80 289 C 87 289, 87 298, 76 306 Z"
        fill="#ffffff"
        className="animar-latido"
        style={{ transformOrigin: "76px 297px" }}
      />
      <rect x="102" y="286" width="130" height="9" rx="4.5" fill="#78350f" />
      <rect x="102" y="303" width="150" height="7" rx="3.5" fill="#92400e" opacity="0.6" />

      <rect x="48" y="344" width="224" height="26" rx="13" fill="#0EA5A4" />
      <rect x="90" y="353" width="140" height="8" rx="4" fill="#ffffff" opacity="0.9" />
    </svg>
  );
}

export function IlustracionBlobDecorativo({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 200 200" className={className} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M45.6,-59.6C58.4,-51.6,67.4,-36.8,71.9,-20.7C76.5,-4.6,76.6,12.8,70.2,27.5C63.8,42.1,50.9,54,35.9,62.6C20.9,71.1,3.7,76.3,-13.9,75.6C-31.5,74.9,-49.5,68.3,-61.5,55.9C-73.6,43.5,-79.7,25.3,-80.5,6.7C-81.3,-11.9,-76.8,-30.9,-65.6,-44.5C-54.4,-58.1,-36.5,-66.3,-18.9,-69.6C-1.3,-72.9,16,-71.3,45.6,-59.6Z"
        transform="translate(100 100)"
        fill="currentColor"
      />
    </svg>
  );
}
